import { jsx } from '@emotion/react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { Link } from '../../navigation/Link/Link.es.js';
import { ColorsCSS, Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { TypographyPDL } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';

const Styles = labelStyles("MenuItem", {
  content: (props) => [
    Object.assign(Object.assign({}, TypographyPDL("--zds-body-2", "paragraph3Medium")), {
      alignItems: "center",
      borderRadius: "var(--zds-radius-small, 3px)",
      color: ColorsCSS.neutral700,
      display: "flex",
      height: "var(--zds-size-medium, 44px)",
      lineHeight: "var(--zds-size-medium, 44px)",
      padding: "0 var(--zds-space-12, 10px)",
      textDecoration: "none",
      outline: "none",
      width: "100%",
      // Bump specificity with `[class]` since these states
      // should have precedence over `isSelected`.
      "&:not([disabled]):hover, &:not([disabled]):focus": {
        backgroundColor: `var(--zds-ui-primary-weakest, ${Colors.blue10})`,
        color: `var(--zds-ui-primary-stronger, ${Colors.blue})`,
        fontWeight: props.isSelected ? 600 : 500
      },
      "&[disabled]": {
        color: ColorsCSS.neutral500,
        cursor: "not-allowed"
      }
    }),
    props.isSelected && withModifier("selected", {
      backgroundColor: ColorsCSS.neutral200,
      fontWeight: 600
    })
  ],
  text: {
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }
});
const MenuItem = (props) => {
  const Tag = props.href && !props.disabled ? Link : "button";
  const isLink = Tag === Link;
  const ariaLabel = props.isSelected ? `${props.ariaLabel || props.children}, selected` : props.ariaLabel;
  const conditionalProps = isLink ? {
    ariaLabel,
    href: props.href,
    rel: props.rel
  } : {
    "aria-label": ariaLabel,
    type: "button",
    disabled: props.disabled
  };
  const liRole = props.role ? { role: "none" } : null;
  return jsx(
    "li",
    Object.assign({}, liRole, { "data-zds": true }),
    jsx(
      Tag,
      Object.assign({}, conditionalProps, {
        component: isLink ? props.component : void 0,
        "data-zds": true,
        // @ts-ignore doesn't understand Link[color=null]
        color: isLink ? null : void 0,
        css: Styles.content(props),
        href: props.href,
        onClick: props.onClick,
        role: props.role
      }),
      jsx("span", { css: Styles.text, "data-zds": true }, props.children)
    )
  );
};

export { MenuItem };
//# sourceMappingURL=MenuItem.es.js.map
